<template>
  <article class="feed-item event notification">
    <div class="time">{{ formattedTime }}</div>

    <div class="feed-item-content">
      <div class="author">{{ author }}</div>
      <div class="action">{{ action }}</div>

      <span
          v-for="(receiver, idx) in receivers"
          :key="idx"
          class="receiver"
      >
        {{ receiver }}
      </span>
    </div>
  </article>
</template>

<script lang="ts">
import { PropType }         from 'vue';
import FeedRecord           from '@/core/services/Feeds/FeedRecord';
import NotificationLogEntry from '@/core/services/Feeds/NotificationLogEntry';

export default defineComponent({
  name: 'FeedItemNotification',

  props: {
    record: {
      type:     Object as PropType<FeedRecord>,
      required: true,
    },
  },

  computed: {
    payload(): NotificationLogEntry {
      return this.record.payload as NotificationLogEntry;
    },

    author(): string {
      return this.payload.author?.name ?? 'Робот автоматически';
    },

    action(): string {
      return 'уведомил(а)';
    },

    receivers(): string[] {
      return this.payload.receivers.map(
        receiver => `${receiver.name} <${receiver.email}>`,
      );
    },

    formattedTime(): string {
      return this.record.time.format('HH|mm');
    },
  },
});
</script>